/** DOM ids used for auto-scroll between flow steps. */
export const TALKING_AVATAR_IMAGE_MODE_ANCHOR_ID = "talking-avatar-image-mode";
export const TALKING_AVATAR_STYLE_ANCHOR_ID = "talking-avatar-style";
export const TALKING_AVATAR_BACKGROUND_ANCHOR_ID = "talking-avatar-background";
export const TALKING_AVATAR_PREVIEW_ANCHOR_ID = "talking-avatar-preview";
export const TALKING_AVATAR_DIALOGUE_ANCHOR_ID = "talking-avatar-dialogue";
export const TALKING_AVATAR_VOICE_ANCHOR_ID = "talking-avatar-voice";

export const TALKING_AVATAR_MAX_WORDS = 60;
export const TALKING_AVATAR_MAX_BG_CHARS = 500;

/** Hero showcase — same flow as Product Studio, but the "after" is a video.
 *  Uploaded by `server/scripts/upload-talking-avatar-hero.ts`. Re-run that
 *  script when you want to swap the example. */
export const TALKING_AVATAR_HERO_BEFORE =
  "https://cdn.todowith.ai/hero/hero-talking-avatar-before.webp";
export const TALKING_AVATAR_HERO_AFTER =
  "https://cdn.todowith.ai/hero/hero-talking-avatar-after-v2.mp4";
